export default __webpack_public_path__ + "static/media/job_offer10_l.c5241ee7.jpg";